import React from "react";

import styles from "./Select.module.css";

export type SelectProps = React.PropsWithChildren<{
  className?: string;
}> &
  JSX.IntrinsicElements["select"];

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = "", children, ...props }, ref) => {
    return (
      <select className={`${styles.root} ${className}`} {...props} ref={ref}>
        {children}
      </select>
    );
  }
);

Select.displayName = "Select";
